import { ValuationApproachDependency } from 'api';

type ValidationStrategy = (dependency: ValuationApproachDependency) => boolean;

const strategies = new Map<string, ValidationStrategy>([
  [
    `${ValuationApproachDependency.approach_type.PUBLIC_COMPS}::${ValuationApproachDependency.approach_type.BACKSOLVE}`,
    dependency =>
      Boolean(dependency.valuations_approach_backsolve?.as_of_date) &&
      Boolean(dependency.valuations_approach_backsolve!.adjustment_selected),
  ],
]);

const getStrategyKey = (
  sourceType: ValuationApproachDependency['approach_type'],
  dependencyType: ValuationApproachDependency['approach_type']
) => `${sourceType}::${dependencyType}`;

const validateRecalculationInputs = ({
  sourceOfTruthApproach,
  affectedApproaches,
}: {
  sourceOfTruthApproach: ValuationApproachDependency;
  affectedApproaches: ValuationApproachDependency[];
}) => {
  const sourceType = sourceOfTruthApproach.approach_type;

  return affectedApproaches.filter(dependency => {
    const dependencyType = dependency.approach_type;
    const strategy = strategies.get(getStrategyKey(sourceType, dependencyType));

    // If no specific rule, block recalculation by default (fail safe)
    return strategy ? strategy(dependency) : false;
  });
};

export default validateRecalculationInputs;
